import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import client, { apiError } from '../api/client';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState(params.get('email') || '');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const verify = async (e) => {
    e.preventDefault();
    setError(''); setInfo(''); setLoading(true);
    try {
      const { data } = await client.post('/auth/verify-email', { email, code });
      setInfo(data.message);
      setTimeout(() => navigate('/login'), 900);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setError(''); setInfo('');
    try {
      const { data } = await client.post('/auth/resend-code', { email, purpose: 'email_verify' });
      setInfo(data.message);
    } catch (err) {
      setError(apiError(err));
    }
  };

  return (
    <div className="container-narrow" style={{ marginTop: 48 }}>
      <div className="card card-pad-lg">
        <h1>Verify your email</h1>
        <p className="muted small">Enter the 6-digit code we sent to your inbox.</p>
        <div className="divider" />
        {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}
        {info && <div className="alert alert-ok" style={{ marginBottom: 14 }}>{info}</div>}
        <form onSubmit={verify}>
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="field">
            <label>Verification code</label>
            <input value={code} onChange={(e) => setCode(e.target.value)} maxLength={6}
              inputMode="numeric" placeholder="123456" required />
          </div>
          <button className="btn btn-primary btn-block" style={{ marginTop: 18 }} disabled={loading}>
            {loading ? <span className="spinner" /> : 'Verify email'}
          </button>
        </form>
        <div className="row-between" style={{ marginTop: 16 }}>
          <button className="btn btn-ghost btn-sm" onClick={resend}>Resend code</button>
          <Link className="small" to="/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
